export const REGION_OPTIONS = [
  'Ahvenanmaa',
  'Etelä-Karjala',
  'Etelä-Pohjanmaa',
  'Etelä-Savo',
  'Kainuu',
  'Kanta-Häme',
  'Keski-Pohjanmaa',
  'Keski-Suomi',
  'Kymenlaakso',
  'Lappi',
  'Päijät-Häme',
  'Pirkanmaa',
  'Pohjanmaa',
  'Pohjois-Karjala',
  'Pohjois-Pohjanmaa',
  'Pohjois-Savo',
  'Satakunta',
  'Uusimaa',
  'Varsinais-Suomi',
];

const MUNICIPALITIES_RAW = `020Akaa
005Alajärvi
009Alavieska
010Alavus
016Asikkala
018Askola
019Aura
035Brändö
043Eckerö
046Enonkoski
047Enontekiö
049Espoo
050Eura
051Eurajoki
052Evijärvi
060Finström
061Forssa
062Föglö
065Geta
069Haapajärvi
071Haapavesi
072Hailuoto
074Halsua
075Hamina
076Hammarland
077Hankasalmi
078Hanko
079Harjavalta
081Hartola
082Hattula
086Hausjärvi
111Heinola
090Heinävesi
091Helsinki
097Hirvensalmi
098Hollola
102Huittinen
103Humppila
105Hyrynsalmi
106Hyvinkää
108Hämeenkyrö
109Hämeenlinna
139Ii
140Iisalmi
142Iitti
143Ikaalinen
145Ilmajoki
146Ilomantsi
153Imatra
148Inari
149Inkoo
151Isojoki
152Isokyrö
165Janakkala
167Joensuu
169Jokioinen
170Jomala
171Joroinen
172Joutsa
176Juuka
177Juupajoki
178Juva
179Jyväskylä
181Jämijärvi
182Jämsä
186Järvenpää
202Kaarina
204Kaavi
205Kajaani
208Kalajoki
211Kangasala
213Kangasniemi
214Kankaanpää
216Kannonkoski
217Kannus
218Karijoki
224Karkkila
226Karstula
230Karvia
231Kaskinen
232Kauhajoki
233Kauhava
235Kauniainen
236Kaustinen
239Keitele
240Kemi
320Kemijärvi
241Keminmaa
322Kemiönsaari
244Kempele
245Kerava
249Keuruu
250Kihniö
256Kinnula
257Kirkkonummi
260Kitee
261Kittilä
263Kiuruvesi
265Kivijärvi
271Kokemäki
272Kokkola
273Kolari
275Konnevesi
276Kontiolahti
280Korsnäs
284Koski Tl
285Kotka
286Kouvola
287Kristiinankaupunki
288Kruunupyy
290Kuhmo
291Kuhmoinen
295Kumlinge
297Kuopio
300Kuortane
301Kurikka
304Kustavi
305Kuusamo
312Kyyjärvi
316Kärkölä
317Kärsämäki
318Kökar
398Lahti
399Laihia
400Laitila
407Lapinjärvi
402Lapinlahti
403Lappajärvi
405Lappeenranta
408Lapua
410Laukaa
416Lemi
417Lemland
418Lempäälä
420Leppävirta
421Lestijärvi
422Lieksa
423Lieto
425Liminka
426Liperi
444Lohja
430Loimaa
433Loppi
434Loviisa
435Luhanka
436Lumijoki
438Lumparland
440Luoto
441Luumäki
475Maalahti
478Maarianhamina - Mariehamn
480Marttila
481Masku
483Merijärvi
484Merikarvia
489Miehikkälä
491Mikkeli
494Muhos
495Multia
498Muonio
499Mustasaari
500Muurame
503Mynämäki
504Myrskylä
505Mäntsälä
508Mänttä-Vilppula
507Mäntyharju
529Naantali
531Nakkila
535Nivala
536Nokia
538Nousiainen
541Nurmes
543Nurmijärvi
545Närpiö
560Orimattila
561Oripää
562Orivesi
563Oulainen
564Oulu
309Outokumpu
576Padasjoki
577Paimio
578Paltamo
445Parainen
580Parikkala
581Parkano
599Pedersören kunta
583Pelkosenniemi
854Pello
584Perho
592Petäjävesi
593Pieksämäki
595Pielavesi
598Pietarsaari
601Pihtipudas
604Pirkkala
607Polvijärvi
608Pomarkku
609Pori
611Pornainen
638Porvoo
614Posio
615Pudasjärvi
616Pukkila
619Punkalaidun
620Puolanka
623Puumala
624Pyhtää
625Pyhäjoki
626Pyhäjärvi
630Pyhäntä
631Pyhäranta
635Pälkäne
636Pöytyä
678Raahe
710Raasepori
680Raisio
681Rantasalmi
683Ranua
684Rauma
686Rautalampi
687Rautavaara
689Rautjärvi
691Reisjärvi
694Riihimäki
697Ristijärvi
698Rovaniemi
700Ruokolahti
702Ruovesi
704Rusko
707Rääkkylä
729Saarijärvi
732Salla
734Salo
736Saltvik
790Sastamala
738Sauvo
739Savitaipale
740Savonlinna
742Savukoski
743Seinäjoki
746Sievi
747Siikainen
748Siikajoki
791Siikalatva
749Siilinjärvi
751Simo
753Sipoo
755Siuntio
758Sodankylä
759Soini
761Somero
762Sonkajärvi
765Sotkamo
766Sottunga
768Sulkava
771Sund
777Suomussalmi
778Suonenjoki
781Sysmä
783Säkylä
831Taipalsaari
832Taivalkoski
833Taivassalo
834Tammela
837Tampere
844Tervo
845Tervola
846Teuva
848Tohmajärvi
849Toholampi
850Toivakka
851Tornio
853Turku
857Tuusniemi
858Tuusula
859Tyrnävä
886Ulvila
887Urjala
889Utajärvi
890Utsjoki
892Uurainen
893Uusikaarlepyy
895Uusikaupunki
785Vaala
905Vaasa
908Valkeakoski
092Vantaa
915Varkaus
918Vehmaa
921Vesanto
922Vesilahti
924Veteli
925Vieremä
927Vihti
931Viitasaari
934Vimpeli
935Virolahti
936Virrat
941Vårdö
946Vöyri
976Ylitornio
977Ylivieska
980Ylöjärvi
981Ypäjä
989Ähtäri
992Äänekoski`;

export const MUNICIPALITY_OPTIONS = MUNICIPALITIES_RAW
  .split('\n')
  .map((line) => line.trim())
  .filter(Boolean)
  .map((line) => line.replace(/^\d+\s*/, '').trim())
  .sort((left, right) => left.localeCompare(right, 'fi'));